import { render, staticRenderFns } from "./DashboardMyRecordings.vue?vue&type=template&id=7d39c46c&scoped=true"
import script from "./DashboardMyRecordings.vue?vue&type=script&lang=js"
export * from "./DashboardMyRecordings.vue?vue&type=script&lang=js"
import style0 from "./DashboardMyRecordings.vue?vue&type=style&index=0&id=7d39c46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d39c46c",
  null
  
)

export default component.exports